if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          'input',
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, {
              ...fetchConfig(),
              ...{ body },
            })
            .then((response) => response.json())
            .then((data) => {
              const cartNoteToggles = document.querySelectorAll('input[id="ShowCartNote"]');

              cartNoteToggles.forEach(cartNoteToggle => {
                if (data.note != '') {
                  cartNoteToggle.setAttribute('checked', true);
                } else {
                  cartNoteToggle.removeAttribute('checked');
                }
              });
            })
            .catch((error) => console.error(error));
          }, ON_CHANGE_DEBOUNCE_TIMER),
        );
      }
    },
  );
}
